import { Product } from '~/types';
import axios from '~/utils/axios';

export const getProducts = () => {
  return axios.get(`/products/deprecated`).then((response) => {
    return response.data;
  });
};

export const getProductById = (id: string) => {
  return axios.get<Product>(`/products/${id}`);
};

export const getSolutionProducts = (solutionId: string) => () => {
  return axios.get<Product[]>(`/solutions/${solutionId}/products?page=1&perPage=999`);
};

export const getAllSolutionProducts = (solutionId: string) => {
  return axios
    .get<Product[]>(`/solutions/${solutionId}/products?page=1&perPage=25`)
    .then((res) => res.data);
};

export const getAllProducts = () => {
  return axios.get<Product[]>(`/products?page=1&perPage=999`).then((res) => res.data);
};

export const getLedgerSystems = () => {
  return axios.get<string[]>(`/ledgerSystems`).then((res) => res.data);
};
